import { render, staticRenderFns } from "./MeetingMinutes.vue?vue&type=template&id=2b2440de&scoped=true&"
import script from "./MeetingMinutes.vue?vue&type=script&lang=js&"
export * from "./MeetingMinutes.vue?vue&type=script&lang=js&"
import style0 from "./MeetingMinutes.vue?vue&type=style&index=0&id=2b2440de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2440de",
  null
  
)

export default component.exports